import { AbstractControl, ValidationErrors } from '@angular/forms';

export const PasswordStrengthValidator = function (
  control: AbstractControl
): ValidationErrors | null {
  const value: string = control.value || '';

  if (!value) {
    return null;
  }

  const pwdPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

  if (pwdPattern.test(value) === false) {
    return {
      passwordStrength: `Password must contain 8 characters, one upper case letter, one special character and one numeric`,
    };
  }
};
